import { render } from "./OfferAvailable.vue?vue&type=template&id=47638a67&scoped=true"
import script from "./OfferAvailable.vue?vue&type=script&lang=js"
export * from "./OfferAvailable.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-47638a67"

export default script